import React from 'react'
import * as RE from 'helpers/ramda-ext'
import { withTheme } from 'styled-components'

// type Props = {
//   children: Node,
//   theme: Theme
// }

const ThemeLoader = ({ children, theme }) => (
  <If condition={RE.isNotEmptyOrNil(theme)}>
    {children}
  </If>
)

export { ThemeLoader }

export default withTheme(ThemeLoader)
